import { Select } from "antd";
import useWarehouseDock from "../customHooks/useWarehouseDock";
import useWarehouseReceivingZone from "../customHooks/useWarehouseReceivingZone";
import { useEffect } from "react";

export const warehouseDockValidator = (dependencyField, zones) => ({ getFieldValue }) => ({
  validator: (_, value) => {
    if (!zones) return Promise.resolve();
   
    const zoneId = getFieldValue(dependencyField);
    const selectedZone = zones.find(z => z.id === zoneId);

    if (selectedZone?.zoneType.isDockingZone && !value) {
      return Promise.reject(new Error("At least one dock must be selected"));
    }

    return Promise.resolve();
  },
});

const WarehouseDockSelect = ({ warehouseId, receivingZoneId, onChange, value, ...rest }) => {
  const { data, isLoading } = useWarehouseDock({ warehouseId, receivingZoneId });
  const { data: receivingZones } = useWarehouseReceivingZone(warehouseId);

  const selectedZone = receivingZones?.find(r => r.id === receivingZoneId);

  useEffect(() => {
    if (!isLoading && data?.length === 1 && !value) {
      onChange?.(data[0].id);
    }
  }, [receivingZoneId, data, isLoading, onChange, value]);

  return (
    <Select disabled={isLoading || !selectedZone?.zoneType?.isDockingZone} onChange={onChange} value={value} {...rest}>
      {data?.map(w => (
        <Select.Option key={w.id} value={w.id}>{w.name}</Select.Option>
      ))}
    </Select>
  );
};

export default WarehouseDockSelect;